import React from "react";
import {
	Snackbar,
	SnackbarContent,
	IconButton,
	Typography,
	makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

const useStyles = makeStyles((theme) => ({
	root: {
		borderRadius: 12,
		display: "flex",
		alignItems: "flex-start",
		backgroundColor: "#fff",
		color: "#333",
		boxShadow: theme.shadows[4],
		padding: theme.spacing(1.5),
		borderLeft: (props) =>
			props.variant === "success"
				? "5px solid #9cc54b"
				: "5px solid #f44336",
	},
	icon: {
		fontSize: 28,
		marginRight: theme.spacing(1.5),
		marginTop: 2,
		color: (props) =>
			props.variant === "success" ? "#9cc54b" : "#f44336",
		animation: `$wiggle 1s ease-in-out`,
		animationIterationCount: 2, // runs once
	},
	"@keyframes wiggle": {
		"0%": {transform: "rotate(0deg)"},
		"15%": {transform: "rotate(-15deg)"},
		"30%": {transform: "rotate(10deg)"},
		"45%": {transform: "rotate(-10deg)"},
		"60%": {transform: "rotate(6deg)"},
		"75%": {transform: "rotate(-4deg)"},
		"100%": {transform: "rotate(0deg)"},
	},
	content: {
		flex: 1,
		padding: 0,
	},
	title: {
		fontWeight: 600,
	},
	description: {
		marginTop: -2,
	},
	closeButton: {
		padding: 4,
		marginLeft: theme.spacing(1),
		color: "#888",
	},
}));

const FeedbackToast = ({open, variant = "success", title, description, onClose}) => {
	const classes = useStyles({variant});

	return (
		<Snackbar
			anchorOrigin={{vertical: "top", horizontal: "right"}}
			open={open}
			onClose={onClose}
			autoHideDuration={3000} // auto-dismiss after 3s
		>
			<SnackbarContent
				className={classes.root}
				message={
					<div style={{display: "flex"}}>
						{variant === "success" ? (
							<CheckCircleIcon className={classes.icon}/>
						) : (
							<ErrorIcon className={classes.icon}/>
						)}
						<div className={classes.content}>
							<Typography variant="subtitle1" className={classes.title}>
								{title}
							</Typography>
							{description && (
								<Typography
									variant="body2"
									color="textSecondary"
									className={classes.description}
								>
									{description}
								</Typography>
							)}
						</div>
					</div>
				}
				action={
					<IconButton className={classes.closeButton} onClick={onClose}>
						<CloseIcon fontSize="small"/>
					</IconButton>
				}
			/>
		</Snackbar>
	);
};

export default FeedbackToast;
